import ResourceTyped from 'Resources/ResourceTyped';
import { STYLE, TYPE } from 'Store/reducers/SystemNotificationReducer';

export type AccountRelation = {
	clientId: number;
	relatedToClientId: number;
	description: string;
	descriptionChildParent: string;
	id: number;
};

class AccountRelationResource extends ResourceTyped<AccountRelation> {
	eventName = 'accountRelation';
	constructor() {
		super('clientrelations');
		this.notifications = {
			save: (_data: unknown, opts?: { isNew?: boolean }) => ({
				title: 'default.saved',
				body: opts?.isNew === false ? 'updated.relation' : 'saved.relation',
				style: STYLE.SUCCESS,
				icon: 'check',
				type: TYPE.BODY
			}),
			saveError: () => ({
				title: 'default.error',
				body: 'saveError.relation',
				style: STYLE.ERROR,
				icon: 'times',
				type: TYPE.BODY
			}),
			delete: () => ({
				title: 'default.saved',
				body: 'deleted.relation',
				style: STYLE.SUCCESS,
				icon: 'check',
				type: TYPE.BODY
			}),
			deleteError: () => ({
				title: 'default.error',
				body: 'deleteError.relation',
				style: STYLE.ERROR,
				icon: 'times',
				type: TYPE.BODY
			})
		};
	}

	/** Relation labels already used in this account, most used first. */
	getDescriptions(): Promise<string[]> {
		return this._getRequest('descriptions', { methodName: 'getDescriptions' }).then(
			(res: { data?: { data?: string[] } }) => res.data?.data ?? []
		);
	}
}

const accountRelationResource = new AccountRelationResource();

export default accountRelationResource;
